import {PAYMENT_REMINDER_VARIABLES} from "@evennt-tech/api-v2-core";

export const STAND_DEFAULT_VARIABLES = [
  "Stand Number",
  "Stand Size",
  "Open Sides",
  "Wall Length",
  "Build Type",
];

export const SHOW_DEFAULT_VARIABLES = [
  "Venue name",
  "Show start date",
  "Show end date",
  "Show name",
  "Venue Address",
  "Venue City",
  "Venue Country",
  "Postcode",
];

export const ONSITE_DETAILS_VARIABLES = [
  "Contact Name",
  "Contact phone number",
  "Contact email",
  "Additional phone number/Fax",
];

export enum RichTextDefaultVariableSetName {
  stand = "stand",
  show = "show",
  onsiteDetails = "onsiteDetails",
  paymentReminder = "paymentReminder",
}

export const RICH_TEXT_DEFAULT_VARIABLES_BY_NAME: Record<
  RichTextDefaultVariableSetName,
  string[]
> = {
  [RichTextDefaultVariableSetName.stand]: STAND_DEFAULT_VARIABLES,
  [RichTextDefaultVariableSetName.show]: SHOW_DEFAULT_VARIABLES,
  [RichTextDefaultVariableSetName.onsiteDetails]: ONSITE_DETAILS_VARIABLES,
  [RichTextDefaultVariableSetName.paymentReminder]: PAYMENT_REMINDER_VARIABLES,
};

export const RICH_TEXT_DEFAULT_VARIABLE_SET_LABEL_BY_TYPE: Record<
  RichTextDefaultVariableSetName,
  string
> = {
  [RichTextDefaultVariableSetName.stand]: "Stand properties",
  [RichTextDefaultVariableSetName.show]: "Show details",
  [RichTextDefaultVariableSetName.onsiteDetails]: "On-site contact details",
  [RichTextDefaultVariableSetName.paymentReminder]:
    "Payment reminder variables",
};
